<template>
  <div class="sku-page">
    <!-- Header -->
    <div class="sku-header">
      <div>
        <span class="header-eyebrow">Inventario</span>
        <h2 class="header-title">SKU &amp; Materiales</h2>
      </div>
      <div class="header-actions">
        <button class="btn-sku btn-sku--ghost" @click="imgTable = !imgTable">
          <i :class="imgTable ? 'fa-solid fa-camera' : 'fa-solid fa-camera-slash'"></i>
          {{ imgTable ? 'Ocultar img' : 'Ver img' }}
        </button>
      </div>
    </div>

    <!-- KPI Strip -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">SKUs</span>
        <span class="kpi-value">{{ listSku.length }}</span>
        <span class="kpi-foot">variantes</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Seleccionados</span>
        <span class="kpi-value" :class="selectedSku.length > 0 ? 'kpi-value--accent' : ''">{{ selectedSku.length }}</span>
        <span class="kpi-foot">SKUs activos</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Materiales</span>
        <span class="kpi-value">{{ listMateriales.length }}</span>
        <span class="kpi-foot">disponibles</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Asociaciones</span>
        <span class="kpi-value">{{ listAllSkuMaterial.length }}</span>
        <span class="kpi-foot">SKU-material</span>
      </div>
    </div>

    <!-- Panels -->
    <div class="panels" :class="{ 'panels--title': modo === 'title' }">
      <!-- Panel SKU -->
      <div class="panel panel--sku">
        <div class="panel__header">
          <div class="segmented">
            <button
              class="segmented__btn"
              :class="{ 'segmented__btn--active': modo === 'sku' }"
              @click="modo = 'sku'"
            >SKU</button>
            <button
              class="segmented__btn"
              :class="{ 'segmented__btn--active': modo === 'title' }"
              @click="modo = 'title'"
            >Title</button>
          </div>
          <span class="panel__badge">{{ modo === 'title' ? linesTitle.length : linesSku.length }}</span>
        </div>

        <div class="panel__toolbar">
          <div class="search-box search-box--full">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input
              type="text"
              class="search-box__input"
              :placeholder="modo === 'title' ? 'Buscar title o SKU...' : 'Buscar SKU...'"
              v-model="buscarSku"
            />
          </div>
          <div class="panel__toolbar-actions">
            <button class="btn-mini" @click="selectAllRows" title="Seleccionar todos">
              <i class="fa-solid fa-check-double"></i> Todos
            </button>
            <button class="btn-mini" @click="clearSelected" title="Limpiar seleccion">
              <i class="fa-solid fa-xmark"></i> Limpiar
            </button>
            <button class="btn-mini btn-mini--accent" @click="copySku()" title="Copiar SKUs">
              <i class="fa-solid fa-copy"></i> Copiar
            </button>
          </div>
        </div>

        <div class="panel__table">
          <b-table
            ref="selectableTableSku"
            :items="modo === 'title' ? linesTitle : linesSku"
            :fields="modo === 'title' ? columnasTitle : columnasSku"
            class="mb-0"
            no-border-collapse
            sort-icon-left
            selectable
            responsive
            @row-selected="onRowSelected"
            select-mode="range"
            sticky-header="calc(100vh - 477px)"
            small
            thead-class="table-head"
            tbody-tr-class="table-row-sku"
            :busy="cargandoSku"
            show-empty
          >
            <template #table-busy>
              <div class="estado-carga">
                <b-spinner small class="mr-50" />
                <span>Cargando SKUs de Shopify…</span>
              </div>
            </template>
            <template #empty>
              <div v-if="errorSku" class="empty-state empty-state--error">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <span>No se pudieron cargar los SKUs</span>
                <button class="btn-mini" @click="cargarSkus()"><i class="fa-solid fa-rotate-right"></i> Reintentar</button>
              </div>
              <div v-else class="empty-state">
                <i class="fa-solid fa-magnifying-glass"></i>
                <span>Sin resultados</span>
              </div>
            </template>
            <template #cell(sku)="data">
              <span class="cell-sku">{{ data.item.sku }}</span>
            </template>
            <template #cell(title)="data">
              <span class="cell-title" :title="data.item.title">{{ data.item.title }}</span>
            </template>
            <template #cell(numSkus)="data">
              <span class="cell-text">{{ data.item.numSkus }}</span>
            </template>
            <template #cell(cantidad)="data">
              <span class="cell-count" v-if="data.item.cantidad">{{ data.item.cantidad }}</span>
              <span class="cell-muted" v-else>0</span>
            </template>
            <template #cell(coste)="data">
              <span class="cell-coste" v-if="data.item.coste">
                <template v-if="data.item.costeMin !== undefined && formatEuro(data.item.costeMin) !== formatEuro(data.item.coste)">{{ formatEuro(data.item.costeMin) }} – </template>{{ formatEuro(data.item.coste) }}
              </span>
              <span class="cell-muted" v-else>--</span>
            </template>
          </b-table>
        </div>
      </div>

      <!-- Panel Materiales -->
      <div class="panel panel--materials">
        <div class="panel__header">
          <div class="panel__header-left">
            <h3 class="panel__title">Materiales</h3>
            <span class="panel__badge panel__badge--green" v-if="selectedSku.length > 0">{{ linesSkuMateriales.length }}</span>
            <span class="coste-total" v-if="costeSeleccion" :title="costeSeleccion.titulo">
              <i class="fa-solid fa-euro-sign"></i> {{ costeSeleccion.texto }}
            </span>
          </div>
          <div class="panel__header-right">
            <span class="panel__hint" v-if="selectedSku.length === 0">Selecciona SKU para ver materiales</span>
            <button
              v-if="selectedSku.length > 0 && linesSkuMateriales.length > 0"
              class="btn-sku btn-sku--ghost btn-sku--sm"
              @click="copiarMateriales()"
              title="Copiar los materiales de este SKU para pegarlos en otro"
            >
              <i class="fa-solid fa-copy"></i> Copiar
            </button>
            <button
              v-if="selectedSku.length > 0 && portapapeles.length > 0"
              class="btn-sku btn-sku--green btn-sku--sm"
              @click="pegarMateriales()"
              :title="'Pegar ' + portapapeles.length + ' materiales en los SKU seleccionados'"
            >
              <i class="fa-solid fa-paste"></i> Pegar ({{ portapapeles.length }})
            </button>
            <button
              v-if="selectedSku.length > 0"
              class="btn-sku btn-sku--primary btn-sku--sm"
              @click="openModalAdd()"
            >
              <i class="fa-solid fa-plus"></i> Agregar
            </button>
          </div>
        </div>

        <div class="panel__table">
          <b-table
            :items="linesSkuMateriales"
            :fields="columnasMateriales"
            class="mb-0"
            no-border-collapse
            sort-icon-left
            responsive
            sticky-header="calc(100vh - 395px)"
            small
            thead-class="table-head"
            tbody-tr-class="table-row"
            show-empty
          >
            <template #empty>
              <div v-if="cargandoMateriales && selectedSku.length > 0" class="estado-carga">
                <b-spinner small class="mr-50" />
                <span>Cargando materiales…</span>
              </div>
              <div v-else-if="errorMateriales" class="empty-state empty-state--error">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <span>No se pudieron cargar los materiales</span>
                <button class="btn-mini" @click="load()"><i class="fa-solid fa-rotate-right"></i> Reintentar</button>
              </div>
              <div v-else class="empty-state">
                <i class="fa-solid fa-cubes"></i>
                <span>Sin materiales asociados</span>
              </div>
            </template>

            <template #cell(img)="data">
              <img v-if="data.item.img" :src="data.item.img" class="cell-img" />
              <div v-else class="cell-img-empty"><i class="fa-solid fa-image"></i></div>
            </template>

            <template #cell(nombre)="data">
              <div class="cell-nombre">
                <span class="cell-nombre__name">
                  {{ data.item.nombre }}
                  <!-- Solo cuando no lo llevan todos los SKU seleccionados -->
                  <span
                    v-if="selectedSku.length > 1 && asociados(data.item) < selectedSku.length"
                    class="cell-nombre__parcial"
                    title="Ver qué SKU lo llevan"
                    @click.stop="verQuienLoLleva(data.item)"
                  >{{ asociados(data.item) }}/{{ selectedSku.length }}</span>
                </span>
                <span class="cell-nombre__sub" v-if="data.item.material">{{ data.item.material }}</span>
              </div>
            </template>

            <template #cell(color)="data">
              <!-- Varias versiones (colores) del mismo material entre los SKU seleccionados: una sola fila -->
              <span
                v-if="data.item.agrupado"
                class="cell-nombre__parcial cell-nombre__parcial--color"
                title="Varios colores: ver cuál lleva cada SKU"
                @click.stop="verQuienLoLleva(data.item)"
              >TODOS</span>
              <span class="cell-text" v-else-if="data.item.color">{{ data.item.color }}</span>
              <span class="cell-muted" v-else>--</span>
            </template>

            <template #cell(categoria)="data">
              <span class="badge-cat" v-if="data.item.categoria">{{ data.item.categoria }}</span>
              <span class="cell-muted" v-else>--</span>
            </template>

            <template #cell(proveedor)="data">
              <span class="cell-text" v-if="data.item.proveedor">{{ data.item.proveedor }}</span>
              <span class="cell-muted" v-else>--</span>
            </template>

            <template #cell(cantidad)="data">
              <span class="cell-qty" v-if="data.item.cantidad">{{ data.item.cantidad }}</span>
              <span class="cell-muted" v-else>--</span>
            </template>

            <template #cell(coste)="data">
              <span class="cell-qty" v-if="data.item.coste !== null"><template v-if="data.item.costeMin !== undefined && formatEuro(data.item.costeMin) !== formatEuro(data.item.coste)">{{ formatEuro(data.item.costeMin) }} – </template>{{ formatEuro(data.item.coste) }}</span>
              <span class="cell-muted" v-else title="Sin precio en el material">--</span>
            </template>

            <template #cell(acciones)="data">
              <div class="cell-actions">
                <button v-if="!data.item.agrupado" class="action-btn action-btn--edit" @click="openModalMaterialUpdate(data.item)" title="Modificar cantidad">
                  <i class="fa-solid fa-pen"></i>
                </button>
                <button class="action-btn action-btn--delete" @click="deleteMaterialSku(data.item)" title="Quitar material">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- Modal: Agregar material (seleccion + cantidad en el mismo modal) -->
    <b-modal
      id="modal-materials"
      ref="modal-materials"
      modal-class="modal-sku"
      centered
      hide-header
      hide-footer
      size="lg"
      @hidden="materialSeleccionado = null"
    >
      <div class="add-mat">
        <div class="add-mat__header">
          <div>
            <h4 class="add-mat__title">Agregar material</h4>
            <span class="add-mat__subtitle">a {{ selectedSku.length }} SKU{{ selectedSku.length === 1 ? '' : 's' }}</span>
          </div>
          <button class="add-mat__close" @click="$refs['modal-materials'].hide()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="add-mat__filters">
          <div class="search-box search-box--full">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input
              ref="inputBuscar"
              type="text"
              class="search-box__input"
              placeholder="Buscar nombre, color, ref, proveedor..."
              v-model="buscarMaterial"
              v-on:keyup.enter="seleccionarPrimero()"
            />
          </div>
          <div class="add-mat__chips">
            <button
              class="chip"
              :class="{ 'chip--active': !categoriaFiltro }"
              @click="categoriaFiltro = ''"
            >Todas</button>
            <button
              v-for="cat in categoriasDisponibles"
              :key="cat"
              class="chip"
              :class="{ 'chip--active': categoriaFiltro === cat }"
              @click="categoriaFiltro = categoriaFiltro === cat ? '' : cat"
            >{{ cat }}</button>
          </div>
        </div>

        <div class="add-mat__list">
          <div
            v-for="mat in linesMateriales"
            :key="mat.id"
            class="mat-row"
            :class="{ 'mat-row--selected': materialSeleccionado && materialSeleccionado.id === mat.id }"
            @click="seleccionarMaterial(mat)"
          >
            <img v-if="mat.img" :src="mat.img" class="mat-row__img" />
            <div v-else class="mat-row__img mat-row__img--empty"><i class="fa-solid fa-cube"></i></div>

            <div class="mat-row__info">
              <span class="mat-row__name">
                {{ mat.nombre }}<span class="mat-row__color" v-if="mat.color"> · {{ mat.color }}</span>
              </span>
              <span class="mat-row__sub">
                <span v-if="mat.material">{{ mat.material }}</span>
                <span v-if="mat.material && mat.proveedor"> · </span>
                <span v-if="mat.proveedor">{{ mat.proveedor }}</span>
              </span>
            </div>

            <span class="badge-cat" v-if="mat.categoria">{{ mat.categoria }}</span>

            <span
              v-if="asociadosSeleccion[mat.id]"
              class="mat-row__tag"
              :class="{ 'mat-row__tag--full': asociadosSeleccion[mat.id] === selectedSku.length }"
            >
              <i class="fa-solid fa-check"></i>
              {{ asociadosSeleccion[mat.id] === selectedSku.length ? 'Asociado' : asociadosSeleccion[mat.id] + '/' + selectedSku.length }}
            </span>
          </div>

          <div v-if="linesMateriales.length === 0 && cargandoMateriales" class="estado-carga">
            <b-spinner small class="mr-50" />
            <span>Cargando materiales…</span>
          </div>
          <div v-else-if="linesMateriales.length === 0" class="empty-state">
            <i class="fa-solid fa-magnifying-glass"></i>
            <span>Sin resultados</span>
          </div>
        </div>

        <div class="add-mat__footer">
          <template v-if="materialSeleccionado">
            <div class="add-mat__selected">
              <span class="add-mat__selected-label">Material</span>
              <span class="add-mat__selected-name">{{ nombreMaterialSeleccionado }}</span>
            </div>
            <div class="add-mat__qty">
              <b-form-input
                ref="inputCantidad"
                type="number"
                v-model="cantidadMaterial"
                placeholder="0"
                class="field__input add-mat__qty-input"
                @wheel.prevent
                v-on:keyup.enter="addMaterialSku()"
              />
              <span class="add-mat__unit">{{ tipoMedidasSeleccionado }}</span>
            </div>
            <button class="btn-modal btn-modal--green" @click="addMaterialSku()" :disabled="!cantidadMaterial">
              <i class="fa-solid fa-plus"></i> Agregar
            </button>
          </template>
          <span v-else class="add-mat__hint">Haz clic en un material (o Enter en el buscador para el primero)</span>
        </div>
      </div>
    </b-modal>

    <!-- Modal: Modificar cantidad -->
    <b-modal
      ref="modal-modificar"
      modal-class="modal-sku"
      centered
      hide-header
      hide-footer
      size="sm"
    >
      <div class="modal-custom">
        <div class="modal-custom__header">
          <div class="modal-custom__icon modal-custom__icon--primary">
            <i class="fa-solid fa-pen"></i>
          </div>
          <h4 class="modal-custom__title">Modificar cantidad</h4>
          <p class="modal-custom__subtitle">{{ nombreMaterialSeleccionado }}</p>
        </div>

        <div class="modal-custom__body">
          <div class="field">
            <label class="field__label">Cantidad <span class="field__hint-inline">({{ tipoMedidasSeleccionado }})</span></label>
            <b-form-input
              ref="inputCantidadMod"
              type="number"
              v-model="cantidadMaterial"
              placeholder="0"
              class="field__input field__input--center"
              @wheel.prevent
              v-on:keyup.enter="updateMaterialSku()"
            />
          </div>
        </div>

        <div class="modal-custom__footer">
          <button class="btn-modal btn-modal--ghost" @click="$refs['modal-modificar'].hide()">Cancelar</button>
          <button class="btn-modal btn-modal--primary" @click="updateMaterialSku()" :disabled="!cantidadMaterial">
            <i class="fa-solid fa-check"></i> Guardar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal: Que SKU llevan el material -->
    <b-modal
      ref="modal-quien"
      modal-class="modal-sku"
      centered
      hide-header
      hide-footer
      size="md"
    >
      <div class="modal-custom" v-if="quien">
        <div class="modal-custom__header">
          <div class="modal-custom__icon modal-custom__icon--primary">
            <i class="fa-solid fa-layer-group"></i>
          </div>
          <h4 class="modal-custom__title">{{ quien.nombre }}</h4>
          <p class="modal-custom__subtitle">{{ quien.conMaterial }} de {{ quien.filas.length }} SKUs lo llevan</p>
        </div>

        <div class="modal-custom__body">
          <div class="quien-list">
            <div class="quien-row" v-for="f in quien.filas" :key="f.sku" :class="{ 'quien-row--sin': !f.v }">
              <span class="quien-row__sku">{{ f.sku }}</span>
              <template v-if="f.v">
                <span class="quien-row__color">{{ f.v.color }}</span>
                <span class="quien-row__qty">{{ f.v.cantidad }} ud</span>
              </template>
              <span v-else class="quien-row__none">No lo lleva</span>
            </div>
          </div>
        </div>

        <div class="modal-custom__footer">
          <button class="btn-modal btn-modal--primary" @click="$refs['modal-quien'].hide()">Cerrar</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'
import { prepararSinImagen, cargarImagenesMateriales } from '@/utils/materialesImagenes'
import { BCardBody, BBadge } from 'bootstrap-vue'

export default {
  components: {
    BCardBody,
    BBadge,
  },
  data(){
    return{
      quien: null,
      columnasMateriales: [
        { key: "nombre", label: "Material", sortable: true },
        { key: "color", label: "Color", sortable: true },
        { key: "categoria", label: "Categoria", sortable: true },
        { key: "proveedor", label: "Proveedor", sortable: true },
        { key: "cantidad", label: "UD", sortable: true, thStyle: { width: "70px" } },
        { key: "coste", label: "Coste", sortable: true, thStyle: { width: "90px" } },
        { key: "acciones", label: "", thStyle: { width: "90px" } },
      ],
      columnasSku: [
        { key: "sku", label: "Sku", sortable: true },
        { key: "cantidad", label: "Mat", sortable: true, thStyle: { width: "60px" } },
        { key: "coste", label: "Coste", sortable: true, thStyle: { width: "90px" } },
      ],
      columnasTitle: [
        { key: "title", label: "Title", sortable: true },
        { key: "numSkus", label: "Skus", sortable: true, thStyle: { width: "60px" } },
        { key: "cantidad", label: "Mat", sortable: true, thStyle: { width: "56px" } },
        { key: "coste", label: "Coste", sortable: true, thStyle: { width: "145px" } },
      ],
      modo: "title",
      listTitle: [],
      linesTitle: [],
      linesMateriales: [],
      linesSkuMateriales: [],
      linesSku: [],
      listMateriales: [],
      listSku: [],
      listAllSkuMaterial: [],
      selectedSku:[],
      buscarMaterial: "",
      buscarSku: "",
      nombreMaterialSeleccionado: "",
      tipoMedidasSeleccionado: "",
      cantidadMaterial: "",
      materialSeleccionado: null,
      data: null,
      imgTable: false,
      listTipoMedidas: ["Unidades", "Pie Cuadrado", "Metro cuadrado", "Metro lineal"],
      textoBotonGuardar: "Crear Material",
      listCategorias: ["Fidlocks","Imanes","Herrajes","Cremalleras","Cursores","Tintes","Pegamentos","Cintas refuerzo","Fieltro","Microfibra","RPET","Tejidos","Refuerzos","Cuero","Cintas de mochila"],
      materialSkuUpdate: null,
      portapapeles: [],
      categoriaFiltro: "",
      cargandoSku: true,
      errorSku: false,
      cargasMateriales: 0,
      errorMateriales: false,
    }
  },
  computed: {
    cargandoMateriales(){
      return this.cargasMateriales > 0;
    },
    categoriasDisponibles(){
      return [...new Set(this.listMateriales.map(m => m.categoria).filter(Boolean))].sort();
    },
    // Coste de materiales por SKU (precio por unidad de medida x cantidad).
    // Con varios SKU seleccionados se muestra el rango min - max.
    costeSeleccion(){
      if(this.selectedSku.length === 0) return null;
      let costes = this.selectedSku.map(s => this.costeSku(s.sku));
      let min = Math.min(...costes);
      let max = Math.max(...costes);
      // Se compara el texto formateado: los decimales flotantes daban "66,84 € – 66,84 €"
      if(this.formatEuro(min) === this.formatEuro(max))
        return { texto: this.formatEuro(min), titulo: 'Coste de materiales por SKU' };
      return { texto: this.formatEuro(min) + ' – ' + this.formatEuro(max), titulo: 'Coste de materiales por SKU (min – max)' };
    },
    // idMaterial -> cuantos de los SKU seleccionados ya lo tienen
    asociadosSeleccion(){
      let skus = new Set(this.selectedSku.map(x => x.sku));
      let conteo = {};
      this.listAllSkuMaterial.forEach(el => {
        if(skus.has(el.sku))
          conteo[el.idMaterial] = (conteo[el.idMaterial] || 0) + 1;
      });
      return conteo;
    },
  },
  methods:{
    parseNum(valor){
      let n = parseFloat(String(valor === null || valor === undefined ? '' : valor).replace(',', '.'));
      return isNaN(n) ? null : n;
    },
    formatEuro(valor){
      return valor.toFixed(2).replace('.', ',') + ' €';
    },
    costeSku(sku){
      return this.listAllSkuMaterial
        .filter(el => el.sku === sku)
        .reduce((total, el) => {
          let mat = this.listMateriales.find(m => m.id == el.idMaterial);
          let precio = mat ? this.parseNum(mat.precio) : null;
          let cantidad = this.parseNum(el.cantidad);
          return total + (precio !== null && cantidad !== null ? precio * cantidad : 0);
        }, 0);
    },
    load(){
      axios.post("/uso", {seccion:"skuMateriales"}, { silencioso: true });
      this.errorMateriales = false;
      this.cargasMateriales += 2;

      axios
        .get("/materiales", { params: { sinImg: 1 } })
        .then(response => {
            return response.data;
        })
        .then(res => {
          prepararSinImagen(res);
          this.listMateriales = res;
          this.linesMateriales = res;
          this.calcularNumMateriales();
          // Las fotos llegan despues, por lotes, sin bloquear la tabla
          cargarImagenesMateriales(this.listMateriales);
        })
        .catch(() => { this.errorMateriales = true; })
        .finally(() => { this.cargasMateriales--; });

      this.cargarSkus();

      axios
        .get("/materiales/sku")
        .then(response => {
            return response.data;
        })
        .then(res => {
          this.listAllSkuMaterial = res;
          this.calcularNumMateriales();
        })
        .catch(() => { this.errorMateriales = true; })
        .finally(() => { this.cargasMateriales--; });
    },
    cargarSkus(){
      this.cargandoSku = true;
      this.errorSku = false;

      axios
        .get("/articulos/variants")
        .then(response => {
            return response.data;
        })
        .then(res => {
          this.listSku = res.map((x) => {
            return {
              ...x,
              cantidad: '',
              coste: 0
            };
          });

          this.agruparPorTitle();
          this.calcularNumMateriales();
          this.linesSku = this.listSku;
          this.linesTitle = this.listTitle;
        })
        .catch(() => { this.errorSku = true; })
        .finally(() => { this.cargandoSku = false; });
    },
    agruparPorTitle(){
      let grupos = {};
      this.listSku.forEach(sku => {
        let title = sku.productTitle || "Sin title";
        if(!grupos[title])
          grupos[title] = { title: title, skus: [], numSkus: 0, cantidad: '', coste: 0, costeMin: 0 };
        grupos[title].skus.push(sku);
        grupos[title].numSkus++;
      });
      this.listTitle = Object.values(grupos);
    },
    calcularNumMateriales()
    {
      this.listSku.forEach(sku => {
        let serie = this.listAllSkuMaterial.filter(function (el) {
            return el.sku == sku.sku;
        });

        sku.cantidad = serie.length;

        if(sku.cantidad == 0)
          sku.cantidad = ''

        sku.coste = this.costeSku(sku.sku);
      });

      // En title: materiales distintos entre todos sus SKU, contando por nombre
      // (los cueros de distinto color de cada SKU cuentan como un solo material)
      this.listTitle.forEach(grupo => {
        let skus = grupo.skus.map(x => x.sku);
        let ids = new Set(this.listAllSkuMaterial.filter(el => skus.includes(el.sku)).map(el => this.nombreNorm(this.materialPorId(el.idMaterial)) || el.idMaterial));
        grupo.cantidad = ids.size || '';

        // Coste por SKU del title: se ordena por el maximo y se muestra el rango si varia
        let costes = grupo.skus.map(x => x.coste);
        grupo.coste = costes.length ? Math.max(...costes) : 0;
        grupo.costeMin = costes.length ? Math.min(...costes) : 0;
      });
    },
    buscarFuncion(){
      let texto = this.buscarMaterial.toLowerCase();
      this.linesMateriales = this.listMateriales.filter(mat => {
        if(this.categoriaFiltro && mat.categoria !== this.categoriaFiltro)
          return false;
        return [mat.nombre, mat.color, mat.material, mat.ean, mat.ref, mat.proveedor]
          .some(campo => (campo || '').toString().toLowerCase().includes(texto));
      });
    },
    copySku(){
      let skus = "";
      this.selectedSku.forEach(skuData => {
        if(skus.length == 0)
          skus += skuData.sku;
        else
          skus += " " + skuData.sku;
      });
      navigator.clipboard.writeText(skus);
    },
    buscarFuncionSku(){
      this.linesSku = [];

      this.listSku.forEach(mat => {
        if(mat.sku.toLowerCase().includes(this.buscarSku.toLowerCase()))
              this.linesSku.push(mat);
      });

      let texto = this.buscarSku.toLowerCase();
      this.linesTitle = this.listTitle.filter(grupo =>
        grupo.title.toLowerCase().includes(texto) ||
        grupo.skus.some(x => x.sku.toLowerCase().includes(texto))
      );
    },
    onRowSelected(items) {
      // En title se expande a sus SKU: todo lo que se asocie va individualmente a cada SKU
      if(this.modo === 'title')
        this.selectedSku = [].concat(...items.map(grupo => grupo.skus));
      else
        this.selectedSku = items
      this.buscarSkuMaterial();
    },
    selectAllRows() {
      this.$refs.selectableTableSku.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTableSku.clearSelected()
    },
    seleccionarMaterial(data){
       this.nombreMaterialSeleccionado = data.nombre + (data.color ? " " + data.color : "");
       this.tipoMedidasSeleccionado = data.tipoMedidas;
       this.materialSeleccionado = data;

       // Si ya lo tienen los SKU, propone su cantidad actual
       let existente = this.listAllSkuMaterial.find(x => x.idMaterial === data.id && this.selectedSku.some(s => s.sku === x.sku));
       this.cantidadMaterial = existente ? existente.cantidad : "";

       this.$nextTick(() => this.$refs.inputCantidad && this.$refs.inputCantidad.focus());
    },
    seleccionarPrimero(){
      if(this.linesMateriales.length > 0)
        this.seleccionarMaterial(this.linesMateriales[0]);
    },
    buscarSkuMaterial(){
      this.linesSkuMateriales = [];

      this.selectedSku.forEach(skuData => {
        let serie = this.listAllSkuMaterial.filter(function (el) {
            return el.sku == skuData.sku;
        });

        serie.forEach(dataSerie => {
          let materialesFind = this.listMateriales.filter(function (el) {
            return el.id == dataSerie.idMaterial;
          });

          let resMaterials = materialesFind.map((x) => {
            let precio = this.parseNum(x.precio);
            let cantidad = this.parseNum(dataSerie.cantidad);
            return {
              ...x,
              cantidad: dataSerie.cantidad,
              coste: precio !== null && cantidad !== null ? precio * cantidad : null
            };
          });

          let index = this.linesSkuMateriales.findIndex(x => x.id === resMaterials[0].id);

          if(index == -1)
            this.linesSkuMateriales.push(...resMaterials);
        });
      });

      if(this.selectedSku.length > 1)
        this.linesSkuMateriales = this.agruparVersiones(this.linesSkuMateriales);
    },
    // Con varios SKU, las versiones (colores) de un mismo material se muestran en una sola fila
    // con color TODOS; cantidad y coste salen como rango si varian entre versiones
    agruparVersiones(filas){
      const grupos = {};
      filas.forEach(f => {
        const clave = this.nombreNorm(f);
        (grupos[clave] = grupos[clave] || []).push(f);
      });
      const rango = (arr, fmt) => {
        const min = Math.min(...arr), max = Math.max(...arr);
        return fmt(min) === fmt(max) ? fmt(min) : fmt(min) + ' – ' + fmt(max);
      };
      return Object.values(grupos).map(g => {
        if(g.length === 1) return g[0];
        const cantidades = g.map(x => this.parseNum(x.cantidad)).filter(v => v !== null);
        const costes = g.map(x => x.coste).filter(c => c !== null);
        return {
          ...g[0],
          id: 'grupo:' + this.nombreNorm(g[0]),
          color: 'TODOS',
          agrupado: true,
          versiones: g,
          cantidad: cantidades.length ? rango(cantidades, String) : '',
          coste: costes.length ? Math.max(...costes) : null,
          costeMin: costes.length ? Math.min(...costes) : undefined,
        };
      });
    },
    // Ids de material que representa una fila del panel (una fila agrupada representa varios)
    idsDe(item){
      return item.versiones ? item.versiones.map(v => v.id) : [item.id];
    },
    // Cuantos de los SKU seleccionados llevan este material (cualquiera de sus versiones)
    asociados(item){
      const ids = new Set(this.idsDe(item));
      const skus = new Set(this.listAllSkuMaterial.filter(x => ids.has(x.idMaterial)).map(x => x.sku));
      return this.selectedSku.filter(s => skus.has(s.sku)).length;
    },
    copiarMateriales(){
      // Guarda en memoria los materiales visibles (union de los SKU seleccionados) con su cantidad.
      // Las filas agrupadas se copian como sus versiones reales.
      this.portapapeles = [].concat(...this.linesSkuMateriales.map(m => m.versiones || [m]))
        .map(m => ({ idMaterial: m.id, cantidad: m.cantidad }));
    },
    pegarMateriales(){
      // Reutiliza el POST de agregar; salta los materiales que el SKU ya tenga
      let peticiones = [];
      this.selectedSku.forEach(item => {
        this.portapapeles.forEach(mat => {
          let existe = this.listAllSkuMaterial.some(x => x.sku === item.sku && x.idMaterial === mat.idMaterial);
          if(existe) return;
          peticiones.push(
            axios
              .post("/materiales/sku", {sku: item.sku, idMaterial: mat.idMaterial, cantidad: mat.cantidad})
              .then(res => {
                this.listAllSkuMaterial.push({id: res.data.insertId, sku: item.sku, idMaterial: mat.idMaterial, cantidad: mat.cantidad});
              })
          );
        });
      });
      Promise.all(peticiones).then(() => {
        this.calcularNumMateriales();
        this.buscarSkuMaterial();
      });
    },
    openModalAdd(){
      this.materialSeleccionado = null;
      this.cantidadMaterial = "";
      this.$refs['modal-materials'].show();
      setTimeout(()=>{this.$refs.inputBuscar.focus(); }, 300);
    },
    async addMaterialSku(){
      if(!this.materialSeleccionado || !this.cantidadMaterial) return;
      // Copia local: al cerrar el modal se limpia la seleccion y las respuestas llegan despues
      const mat = this.materialSeleccionado;
      const idMaterial = mat.id;
      const cantidad = this.cantidadMaterial;
      const generico = this.esGenerico(mat);

      // Aviso previo: SKU a los que se les va a sustituir el generico (color TODOS) por este color
      if(!generico) {
        const reemplazos = this.selectedSku.filter(item =>
          this.listAllSkuMaterial.some(x => x.sku === item.sku && this.mismoMaterial(x.idMaterial, mat) && this.esGenerico(this.materialPorId(x.idMaterial)))
        );
        if(reemplazos.length) {
          const lista = reemplazos.map(s => s.sku).join(', ');
          const ok = await this.$bvModal.msgBoxConfirm(
            `"${mat.nombre} ${mat.color}" sustituirá a "${mat.nombre} TODOS" en ${reemplazos.length === 1 ? 'el SKU' : reemplazos.length + ' SKU'}: ${lista}. ¿Continuar?`,
            { title: 'Reemplazar material genérico', okTitle: 'Reemplazar', okVariant: 'warning', cancelTitle: 'Cancelar', centered: true }
          );
          if(!ok) return;
        }
      }

      this.selectedSku.forEach(item => {
        // Al agregar por title algunos SKU del grupo pueden tenerlo ya
        let existe = this.listAllSkuMaterial.some(x => x.sku === item.sku && x.idMaterial === idMaterial);
        if(existe) return;

        // El generico (color TODOS) es un placeholder del mismo material:
        // - si el SKU ya tiene una version con color, el generico no se mete
        // - si se mete una version con color, sustituye al generico que tuviera el SKU
        const versiones = this.listAllSkuMaterial.filter(x => x.sku === item.sku && this.mismoMaterial(x.idMaterial, mat));
        if(generico && versiones.length) return;
        versiones.filter(x => this.esGenerico(this.materialPorId(x.idMaterial))).forEach(x => this.borrarAsociacion(x));

        axios
          .post("/materiales/sku", {sku: item.sku, idMaterial: idMaterial, cantidad: cantidad})
          .then(response => {
              return response.data;
          })
          .then(res => {
            this.listAllSkuMaterial.push({id: res.insertId, sku: item.sku, idMaterial: idMaterial, cantidad: cantidad})
            this.calcularNumMateriales();
            this.buscarSkuMaterial();
            window.scrollTo(0, 0);
          });
      });

      this.$refs['modal-materials'].hide()
      this.buscarSkuMaterial();
    },
    openModalMaterialUpdate(data)
    {
      this.nombreMaterialSeleccionado = data.nombre + " " + data.color;

      this.selectedSku.forEach(item => {
        let index = this.listAllSkuMaterial.findIndex(x => (x.sku === item.sku && x.idMaterial === data.id));

        if(index != -1)
        {
          this.materialSkuUpdate = this.listAllSkuMaterial[index];
          this.cantidadMaterial = this.materialSkuUpdate.cantidad;
        }
      });

      this.$refs['modal-modificar'].show();
      setTimeout(()=>{this.$refs.inputCantidadMod.focus(); }, 300);
    },
    updateMaterialSku(){
       this.selectedSku.forEach(item => {
         let index = this.listAllSkuMaterial.findIndex(x => (x.sku === item.sku && x.idMaterial === this.materialSkuUpdate.idMaterial));

         if(index != -1)
         {
            let uptInfo = {id: this.listAllSkuMaterial[index].id, cantidad: this.cantidadMaterial}

            axios
              .post("/materiales/sku/update", uptInfo)
              .then(response => {
                  return response.data;
              })
              .then(res => {
                this.listAllSkuMaterial[index].cantidad = this.cantidadMaterial;
                this.calcularNumMateriales();
                this.buscarSkuMaterial();
              });
         }
      });

      this.$refs['modal-modificar'].hide()
      this.buscarSkuMaterial();
    },
    deleteMaterialSku(data){
      // En una fila agrupada se quitan todas sus versiones
      const ids = new Set(this.idsDe(data));
      this.selectedSku.forEach(item => {
        this.listAllSkuMaterial
          .filter(x => x.sku === item.sku && ids.has(x.idMaterial))
          .forEach(rel => this.borrarAsociacion(rel));
      });
    },
    // Quita una relacion SKU-material (fila de listAllSkuMaterial) en la API y en memoria
    borrarAsociacion(rel){
      return axios
        .post("/materiales/sku/delete", {id: rel.id})
        .then(() => {
          const index = this.listAllSkuMaterial.indexOf(rel);
          if(index !== -1) this.listAllSkuMaterial.splice(index, 1);
          this.calcularNumMateriales();
          this.buscarSkuMaterial();
        });
    },
    materialPorId(id){
      return this.listMateriales.find(m => m.id == id);
    },
    // Qué SKU de los seleccionados llevan este material (y con qué color y cantidad) y cuáles no
    verQuienLoLleva(item){
      const ids = new Set(this.idsDe(item));
      const porSku = {};
      this.listAllSkuMaterial.filter(x => ids.has(x.idMaterial)).forEach(x => {
        const m = this.materialPorId(x.idMaterial);
        porSku[x.sku] = { color: (m && m.color) || '--', cantidad: x.cantidad };
      });
      const filas = this.selectedSku.map(s => ({ sku: s.sku, v: porSku[s.sku] }));
      this.quien = { nombre: item.nombre, filas, conMaterial: filas.filter(f => f.v).length };
      this.$refs['modal-quien'].show();
    },
    nombreNorm(mat){
      return ((mat && mat.nombre) || '').trim().toLowerCase();
    },
    // Material generico: color TODOS (placeholder hasta asignar el color exacto)
    esGenerico(mat){
      return !!mat && ((mat.color || '').trim().toUpperCase() === 'TODOS');
    },
    // Mismo material en otra version (mismo nombre, distinto id: generico <-> color)
    mismoMaterial(idMaterial, mat){
      const m = this.materialPorId(idMaterial);
      return !!m && m.id != mat.id && this.nombreNorm(m) === this.nombreNorm(mat);
    }
  },
  watch: {
    buscarMaterial(){
      this.buscarFuncion();
    },
    categoriaFiltro(){
      this.buscarFuncion();
    },
    imgTable(){
      if(this.imgTable)
      {
        this.columnasMateriales.unshift({
          key: "img",
          label: "Img",
          sortable: false,
          thStyle: { width: "70px" },
        })
      }
      else
      {
        this.columnasMateriales.shift();
      }
    },
    buscarSku(){
      this.buscarFuncionSku();
    },
    modo(){
      this.selectedSku = [];
      this.buscarSkuMaterial();
      this.$nextTick(() => this.clearSelected());
    }
  },
  mounted() {
    this.load();
  }
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$green: #10B981;
$green-dark: #059669;
$danger: #EF4444;
$warning: #F59E0B;
$info: #06B6D4;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.sku-page {
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 8px;
}

// Header
.sku-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
}

.header-eyebrow {
  display: block;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: $primary;
  margin-bottom: 2px;
}

.header-title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: $text;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 8px;
}

// Buttons
.btn-sku {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: $radius-sm;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &--primary {
    background: $primary;
    color: white;
    &:hover { background: $primary-dark; }
  }

  &--green {
    background: $green;
    color: white;
    &:hover { background: $green-dark; }
  }

  &--ghost {
    background: transparent;
    color: $text-muted;
    border: 1px solid $border;
    &:hover { background: $bg; color: $text; }
  }

  &--sm {
    padding: 6px 14px;
    font-size: 12px;
  }
}

// KPI Strip
.kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.kpi-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius-sm;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  box-shadow: $shadow;
}

.kpi-label {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
}

.kpi-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 22px;
  font-weight: 700;
  color: $text;
  font-feature-settings: "tnum";
  margin: 4px 0 2px;

  &--accent { color: $primary; }
}

.kpi-foot {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: $text-muted;
}

// Panels layout
.panels {
  display: grid;
  grid-template-columns: minmax(400px, 1fr) 2fr;
  gap: 16px;
  align-items: start;

  // Los title son largos: panel mas ancho para que quepan en una linea
  &--title { grid-template-columns: minmax(560px, 2fr) 3fr; }
}

.panel {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px 0;
  }

  &__header-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__header-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  // Sin toolbar entre cabecera y tabla: hace falta aire abajo
  &--materials &__header {
    padding-bottom: 14px;
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: $text;
    margin: 0;
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 22px;
    padding: 0 7px;
    border-radius: 12px;
    background: rgba($primary, 0.1);
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 700;
    color: $primary;

    &--green {
      background: rgba($green, 0.1);
      color: $green;
    }
  }

  &__hint {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: $text-muted;
  }

  &__toolbar {
    padding: 12px 18px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__toolbar-actions {
    display: flex;
    gap: 6px;
  }

  &__table {
    border-top: 1px solid $border;
  }
}

// Toggle SKU / Title
.segmented {
  display: inline-flex;
  padding: 3px;
  border-radius: $radius-sm;
  background: $bg;
  border: 1px solid $border;

  &__btn {
    padding: 4px 14px;
    border: none;
    border-radius: 6px;
    background: transparent;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: $text-muted;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover { color: $text; }

    &--active {
      background: $card-bg;
      color: $text;
      box-shadow: $shadow;
    }
  }
}

// Mini buttons
.btn-mini {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid $border;
  background: transparent;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  color: $text-muted;
  cursor: pointer;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    border-color: $primary;
    color: $primary;
  }

  &--accent {
    border-color: rgba($primary, 0.3);
    color: $primary;
    &:hover { background: rgba($primary, 0.05); }
  }
}

// Search
.search-box {
  position: relative;

  &--full { width: 100%; }

  &__icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: $text-muted;
    font-size: 12px;
  }

  &__input {
    width: 100%;
    padding: 7px 12px 7px 32px;
    border: 1px solid $border;
    border-radius: $radius-sm;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    color: $text;
    background: transparent;
    transition: border-color 0.15s ease;

    &::placeholder { color: #CBD5E1; }
    &:focus { outline: none; border-color: $primary; }
  }
}

// Table styles
.sku-page ::v-deep .table-head th {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
  border-top: none;
  border-bottom: 1px solid $border;
  padding: 8px 14px;
  background: transparent;

}

// Los ::v-deep van bajo .sku-page a proposito: si van en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// (ambos atributos en el mismo elemento) y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
// sort-icon-left: bootstrap-vue usa un selector muy especifico (con prefijo [dir]) que hay que superar
.sku-page ::v-deep .table.b-table.table-sm > thead.table-head > tr > th[aria-sort].b-table-sort-icon-left {
  padding-left: 32px;
  background-position: left 12px center;
  background-size: 8px 14px;
}

.sku-page ::v-deep .table-row td,
.sku-page ::v-deep .table-row-sku td {
  padding: 8px 14px;
  vertical-align: middle;
  border-color: lighten($border, 3%);
  font-size: 13px;
}

.sku-page ::v-deep .table-row:hover td {
  background: $bg;
}

// Title: layout fijo para que el title se corte con "..." en vez de forzar scroll horizontal
.sku-page .panels--title ::v-deep .panel--sku table {
  table-layout: fixed;
  width: 100%;
}

.sku-page .panels--title ::v-deep .panel--sku .table-responsive {
  overflow-x: hidden;
}

// SKU table selected row
.sku-page ::v-deep .table-row-sku.b-table-row-selected td {
  background: rgba($primary, 0.06) !important;
}

.sku-page ::v-deep .table-row-sku:hover td {
  background: rgba($primary, 0.03);
}

.cell-sku {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 500;
  color: $text;
}

.cell-title {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: $text;
}

.cell-count {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 600;
  color: $primary;
  font-feature-settings: "tnum";
}

.cell-img {
  width: 50px;
  height: 36px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid $border;
}

.cell-img-empty {
  width: 50px;
  height: 36px;
  border-radius: 5px;
  border: 1px dashed $border;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #CBD5E1;
  font-size: 13px;
}

.cell-nombre {
  display: flex;
  flex-direction: column;

  &__name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: $text;
    line-height: 1.2;
  }

  &__sub {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: $text-muted;
  }

  // "n/N": lo llevan solo algunos de los SKU seleccionados (misma etiqueta que en el modal de agregar)
  &__parcial {
    display: inline-block;
    margin-left: 6px;
    padding: 1px 7px;
    border-radius: 20px;
    background: rgba(#F59E0B, 0.12);
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: #D97706;
    vertical-align: middle;
    cursor: pointer;
    &:hover { background: rgba(#F59E0B, 0.25); }

    // En la columna color (fila agrupada): tamaño de texto de celda
    &--color { margin-left: 0; font-size: 12px; padding: 2px 9px; }
  }
}

.cell-text { font-size: 13px; color: $text; }
.cell-muted { color: #CBD5E1; font-size: 12px; }

.cell-qty {
  font-family: 'JetBrains Mono', monospace;
  font-size: 13px;
  font-weight: 700;
  color: $green;
  font-feature-settings: "tnum";
}

.cell-coste {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 700;
  color: $primary;
  font-feature-settings: "tnum";
  white-space: nowrap;
}

.coste-total {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 9px;
  border-radius: 12px;
  background: rgba($primary, 0.1);
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 700;
  color: $primary;
  font-feature-settings: "tnum";
  white-space: nowrap;
}

.badge-cat {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 20px;
  background: rgba($primary, 0.08);
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  color: $primary;
}

.cell-actions {
  display: flex;
  gap: 4px;
}

.action-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: $text-muted;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  font-size: 11px;

  &--edit:hover {
    background: rgba($primary, 0.1);
    color: $primary;
    border-color: rgba($primary, 0.2);
  }

  &--delete:hover {
    background: rgba($danger, 0.1);
    color: $danger;
    border-color: rgba($danger, 0.2);
  }
}

// Empty state
.estado-carga {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1rem;
  color: #64748b;
  font-size: 0.9rem;
}

.empty-state.empty-state--error {
  color: #ea5455;

  i { color: #ea5455; }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 0;
  color: $text-muted;

  i { font-size: 28px; color: #CBD5E1; }
  span { font-family: 'JetBrains Mono', monospace; font-size: 12px; }
}

// Responsive
@media (max-width: 992px) {
  .panels { grid-template-columns: 1fr; }
  .kpi-strip { grid-template-columns: repeat(2, 1fr); }
  .sku-header { flex-direction: column; align-items: flex-start; gap: 12px; }
}
</style>

<style lang="scss">
// Unscoped: modals, fields, dark mode
.modal-sku {
  .modal-content {
    border-radius: 16px;
    border: 1px solid #E2E8F0;
    box-shadow: 0 20px 60px rgba(0,0,0,0.12), 0 8px 20px rgba(0,0,0,0.06);
    overflow: hidden;
  }

  .modal-body { padding: 0; }
}

.modal-custom {
  &__header {
    text-align: center;
    padding: 28px 28px 0;
  }

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    font-size: 18px;

    &--primary { background: rgba(#3B82F6, 0.1); color: #3B82F6; }
    &--green { background: rgba(#10B981, 0.1); color: #10B981; }
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #1E293B;
    margin: 0 0 4px;
  }

  &__subtitle {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: #64748B;
    margin: 0;
  }

  &__body { padding: 22px 28px; }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 0 28px 24px;
  }
}

// Modal agregar material
.add-mat {
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px 22px 12px;
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 17px;
    font-weight: 700;
    color: #1E293B;
    margin: 0;
  }

  &__subtitle {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: #3B82F6;
    font-weight: 600;
  }

  &__close {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: none;
    background: transparent;
    color: #94A3B8;
    cursor: pointer;
    &:hover { background: #F1F5F9; color: #1E293B; }
  }

  &__filters {
    padding: 0 22px 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-bottom: 1px solid #E2E8F0;
  }

  &__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  &__list {
    flex: 1;
    overflow-y: auto;
    min-height: 200px;
    padding: 6px 10px;
  }

  &__footer {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 22px;
    border-top: 1px solid #E2E8F0;
    background: #F8FAFC;
    min-height: 66px;
  }

  &__hint {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: #94A3B8;
  }

  &__selected {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__selected-label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748B;
  }

  &__selected-name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #1E293B;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__qty {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__qty-input {
    width: 100px;
    text-align: center;
    font-weight: 700;
  }

  &__unit {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: #64748B;
    white-space: nowrap;
  }
}

.chip {
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 20px;
  border: 1px solid #E2E8F0;
  background: transparent;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover { border-color: #3B82F6; color: #3B82F6; }

  &--active {
    background: #3B82F6;
    border-color: #3B82F6;
    color: white;
    &:hover { color: white; }
  }
}

.mat-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 7px 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.1s ease;

  &:hover { background: #F8FAFC; }

  &--selected {
    background: rgba(#10B981, 0.08) !important;
    border-color: rgba(#10B981, 0.4);
  }

  &__img {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 6px;
    object-fit: cover;
    border: 1px solid #E2E8F0;

    &--empty {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #CBD5E1;
      font-size: 13px;
      border-style: dashed;
    }
  }

  &__info {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #1E293B;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__color { font-weight: 400; color: #64748B; }

  &__sub {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: #94A3B8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__tag {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 20px;
    background: rgba(#F59E0B, 0.12);
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: #D97706;

    &--full {
      background: rgba(#10B981, 0.12);
      color: #059669;
    }
  }
}

.field {
  display: flex;
  flex-direction: column;
  gap: 5px;

  &__label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #64748B;
    margin: 0;
  }

  &__hint-inline {
    text-transform: none;
    font-weight: 400;
    letter-spacing: 0;
    color: #94A3B8;
  }

  &__input {
    border-radius: 8px;
    border: 1px solid #E2E8F0;
    padding: 8px 12px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 14px;
    color: #1E293B;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:focus {
      border-color: #3B82F6;
      box-shadow: 0 0 0 3px rgba(#3B82F6, 0.1);
    }

    &--center { text-align: center; font-size: 20px; font-weight: 700; }
  }
}

.btn-modal {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 8px;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &--primary {
    background: #3B82F6;
    color: white;
    &:hover:not(:disabled) { background: #2563EB; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
  }

  &--green {
    background: #10B981;
    color: white;
    &:hover:not(:disabled) { background: #059669; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
  }

  &--ghost {
    background: transparent;
    color: #64748B;
    &:hover { background: #F1F5F9; color: #1E293B; }
  }
}

// Dark mode
.quien-list {
  max-height: 55vh;
  overflow-y: auto;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
}

.quien-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #F1F5F9;
  &:last-child { border-bottom: none; }

  &__sku {
    flex: 1;
    min-width: 0;
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: #1E293B;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__color {
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 6px;
    background: #F1F5F9;
    color: #64748B;
  }

  &__qty {
    min-width: 56px;
    text-align: right;
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 700;
    color: #3B82F6;
    font-feature-settings: "tnum";
  }

  &__none {
    font-size: 11px;
    color: #94A3B8;
  }

  &--sin &__sku { color: #94A3B8; font-weight: 400; }
}

.dark-layout {
  .sku-page {
    .header-title { color: #E2E8F0; }

    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }

    .panel { background: #1E293B; border-color: #334155; }
    .panel__title { color: #E2E8F0; }
    .panel__table { border-color: #334155; }

    .segmented { background: #0F172A; border-color: #334155; }
    .segmented__btn { color: #94A3B8; &:hover { color: #E2E8F0; } }
    .segmented__btn--active { background: #334155; color: #E2E8F0; }

    .btn-mini { border-color: #475569; color: #94A3B8; &:hover { border-color: #3B82F6; color: #3B82F6; } }

    .search-box__input {
      border-color: #334155; color: #E2E8F0;
      &::placeholder { color: #475569; }
      &:focus { border-color: #3B82F6; }
    }

    .table-head th { color: #94A3B8; border-color: #334155; }
    .table-row td, .table-row-sku td { border-color: #334155; }
    .table-row:hover td { background: rgba(255,255,255,0.03); }
    .table-row-sku.b-table-row-selected td { background: rgba(#3B82F6, 0.08) !important; }
    .table-row-sku:hover td { background: rgba(255,255,255,0.03); }

    .cell-sku, .cell-title { color: #E2E8F0; }
    .cell-nombre__name { color: #E2E8F0; }
    .cell-text { color: #E2E8F0; }
    .cell-img { border-color: #334155; }
    .cell-img-empty { border-color: #334155; color: #475569; }
    .action-btn { color: #94A3B8; }
    .empty-state i { color: #475569; }

    .btn-sku--ghost { border-color: #475569; color: #94A3B8; &:hover { background: #334155; color: #E2E8F0; } }
  }

  .modal-sku .modal-content { background: #1E293B; border-color: #334155; }
  .modal-custom__title { color: #E2E8F0; }
  .quien-list { border-color: #334155; }
  .quien-row { border-color: #334155; }
  .quien-row__sku { color: #E2E8F0; }
  .quien-row--sin .quien-row__sku { color: #64748B; }
  .quien-row__color { background: #334155; color: #94A3B8; }
  .add-mat__title, .add-mat__selected-name, .mat-row__name { color: #E2E8F0; }
  .add-mat__filters, .add-mat__footer { border-color: #334155; }
  .add-mat__footer { background: #0F172A; }
  .add-mat__close:hover { background: #334155; color: #E2E8F0; }
  .chip { border-color: #475569; color: #94A3B8; }
  .mat-row:hover { background: rgba(255,255,255,0.03); }
  .mat-row__img { border-color: #334155; }
  .field__label { color: #94A3B8; }
  .field__input { background: #0F172A; border-color: #334155; color: #E2E8F0; &:focus { border-color: #3B82F6; } }
  .btn-modal--ghost { color: #94A3B8; &:hover { background: rgba(255,255,255,0.05); color: #E2E8F0; } }
}
</style>
